import { Box } from '@chakra-ui/react'
import { ScreenContext, useCollection } from '@hb/react'
import { FieldMap, FieldTypes, SupplyKeyword, supplyKeywordsCollection } from '@hb/shared'
import { useContext } from 'react'
import { EditCollection } from '../../../EditCollection'
import { EditedProps } from '../../../EditHeader'
import { FormElement } from '../../../forms/Input'

const supplyKeywordFields: FieldMap = {
  name: 'Supply Keyword',
  children: {
    supplyName: {
      type: FieldTypes.TEXT,
      placeholder: 'Supply / medication name (e.g. IV LR Bag)',
    },
    keywords: {
      name: 'Trigger Keywords',
      itemName: 'Keyword',
      optional: false,
      itemFields: {
        type: FieldTypes.TEXT,
        // cspell:ignore ringer
        placeholder: 'Keyword that triggers detection (e.g. lactated ringer)',
      },
    },
    hcpcsCode: {
      type: FieldTypes.TEXT,
      // cspell:ignore hcpcs
      placeholder: 'HCPCS code (optional, e.g. A4217)',
      optional: true,
    },
  },
}

const SupplyKeywordBody = ({ expanded }: EditedProps<SupplyKeyword>) =>
  expanded ? (
    <Box w="100%" p={4}>
      <FormElement active name="" field={supplyKeywordFields} />
    </Box>
  ) : null

export const SupplyKeywordsAdminView = () => {
  const { contentWidth } = useContext(ScreenContext)
  const data = useCollection(supplyKeywordsCollection)
  if (!data) return null
  return (
    <EditCollection
      collection={supplyKeywordsCollection}
      data={data}
      width={contentWidth}
      ItemComponent={SupplyKeywordBody}
      name="CDI Keyword Library"
      itemPlaceholder="Supply name"
      itemName="Supply Keyword"
    />
  )
}
